/* eslint-disable react/display-name */
import useCurrentPresets from "../../../hooks/use-current-presets"

const withPresetsData = (Component) => (props) => {
  const {
    data: { data: currentPresets = [] } = {},
    status,
    error,
  } = useCurrentPresets()

  return (
    <Component
      {...props}
      presetList={currentPresets}
      isLoading={status === "loading"}
      error={error}
    />
  )
}

export default withPresetsData
